/**
 * Extract search params from a path
 * @param path the path to extract (will ignore path params part)
 * @returns search params as object
 */
const extractSearchParams = (path?: string) => {
  if (!path) {
    return {}
  }

  const search = path.split('?')[1]

  if (!search) {
    return {}
  }

  const clean = search.replace('?', '')

  return clean.split('&').reduce((acc, cur) => {
    const param = cur.split('=')
    return { ...acc, [param[0]]: param[1] }
  }, {} as { [key: string]: string })
}

/**
 * Extract search params from a path
 * @param path the path to extract (will ignore path params part)
 * @returns search params as object
 */
const extractHashParams = (path?: string) => {
  if (!path) {
    return {}
  }

  const search = path.split('#')[1]

  if (!search) {
    return {}
  }

  const clean = search.replace('#', '')

  return clean.split('&').reduce((acc, cur) => {
    const param = cur.split('=')
    return { ...acc, [param[0]]: param[1] }
  }, {} as { [key: string]: string })
}

/**
 * Extract path params from path
 * @param path the path to extract (will ignore search part)
 * @param refPath the path to match
 * @returns path params as object
 */
const extractPathParams = (path: string, refPath: string) => {
  const splittedPath = path.split('?')[0].split('/')
  const splittedRef = refPath.split('/')

  if (splittedPath.length !== splittedRef.length) {
    // cannot extract as path doesn't match ref
    return {}
  }

  return splittedPath.reduce((acc, cur, idx) => {
    const ref = splittedRef[idx]

    if (!ref.includes(':')) {
      return acc
    }

    return { ...acc, [ref.replace(':', '')]: cur }
  }, {} as { [key: string]: string })
}

/**
 * Find path index in a collection, evaluating possible path params
 * @param paths the collection of paths
 * @param path the path to find
 * @returns path index or -1
 */
const matchPath = (paths: string[], path: string) => {
  return paths.findIndex((p) => {
    const splittedPath = path.split('?')[0].split('/')
    const splittedRef = p.split('/')

    if (splittedPath.length !== splittedRef.length) {
      // length doesn't match -> no match possible for path
      return false
    }

    const matching = splittedRef.filter((part, idx) => part.includes(':') || part === splittedPath[idx])
    return matching.length === splittedRef.length
  })
}

export { extractSearchParams, extractPathParams, extractHashParams, matchPath }
